<div class="dialog-container">
  <div class="container">
    <div class="section-container">
      <div class="item-container">
        @if (users && users.items?.length !== 0) {
          @for (item of users.items; track item) {
            <app-user-item (click)="impersonate(item)" [active]="impersonatedUser == item.id" [item]="item"></app-user-item>
          }
        } @else {
          <div class="no-data-container">
            <fa-icon [icon]="['fas', 'baby']" size="2x"></fa-icon>
            <span>{{ "default.buttons.noData" | translate }}</span>
          </div>
        }
      </div>
    </div>
    <div class="pagination-container">
      <div class="input-container">
        <input (keyup.enter)="loadItems()" [(ngModel)]="queryString" matInput />
        <button (click)="loadItems()" class="icon-button search-button">
          <fa-icon [icon]="['fas', 'magnifying-glass']" size="1x"></fa-icon>
        </button>
        @if (queryString) {
          <button (click)="queryString = null; loadItems()" class="icon-button cancel-button">
            <fa-icon [icon]="['fas', 'xmark']" size="1x"></fa-icon>
          </button>
        }
      </div>

      @if (users) {
        <mat-paginator
          (page)="loadItems($event)"
          [hidePageSize]="true"
          [length]="users.totalItems"
          [pageIndex]="users.page"
        [pageSize]="users.pageSize"></mat-paginator>
      }
    </div>
  </div>
</div>

